import React, { useEffect, useRef, useState } from 'react'
import ModalCustom from '../../modal-custom'
import { Button, Col, Form } from 'react-bootstrap'
import LabelCustom from '../../label-custom'
import { Controller, useForm } from 'react-hook-form'
import { DatePicker } from 'antd'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { deleteWorksAPI, updateWorksAPI } from '../../../services/history-works'
import dayjs from 'dayjs'
import Error_false from '../../error/error-false'
import Error_500 from '../../error/error-500'
import SwalCustom from '../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../Constants'
import useNumberInput from '../../../helper/input-fix-num'
const schema = yup
  .object({
    company: yup.string().required('Please, Fill Name of Company'),
    histyPosition: yup.string().required('Please, Fill Position'),
    duty: yup.string().required('Please, Fill Job description'),
    // fromYear: yup.string().required('Please, Fill Start Date'),
    fromYear: yup
      .string()
      .required('Please, Fill Start Date')
      .test(
        'is-toYear-after-adYear',
        'Pleace, re-check Start Year and End Date again',
        function (value) {
          const toYear = this.parent.toYear
          if (!toYear) return true // Skip validation if toYear is not set
          return parseInt(value) <= parseInt(toYear)
        }
      ),

    toYear: yup.string().required('Please, Fill End Date'),
    histyReason: yup.string().required('Please, Fill Reason')
  })
  .required()

export default function EditWorkHistory({
  param,
  setIsSave,
  showCreate,
  isSave,
  fnGetWorks,
  setShowCreate,
  detail
}) {
  const {
    control,
    setValue,
    setError,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })

  const inputRef = useRef(null)
  const handleKeyDownNum = useNumberInput(inputRef)

  useEffect(() => {
    setValue('company', detail?.company ?? '')
    setError('company', false)

    setValue('histyPosition', detail?.position ?? '')
    setError('histyPosition', false)

    setValue('duty', detail?.duty ?? '')
    setError('duty', false)

    setValue('fromYear', detail?.from_year ?? '')
    setError('fromYear', false)

    setValue('toYear', detail?.to_year ?? '')
    setError('toYear', false)

    setValue('histyReason', detail?.reason ?? '')
    setError('histyReason', false)
  }, [
    detail?.company,
    detail?.duty,
    detail?.fromYear,
    detail?.from_year,
    detail?.histyPosition,
    detail?.histyReason,
    detail?.position,
    detail?.reason,
    detail?.toYear,
    detail?.to_year,
    setError,
    setValue
  ])
  const onSubmit = async (data) => {
    setIsSave(true)
    const body = { ...data }
    const params = { ...param, histyWorkId: detail.id }
    createWorks(params, body)
  }
  const createWorks = async (params, body) => {
    try {
      const data = await updateWorksAPI(params, body)
      if (data?.status) {
        SwalCustom({
          title: 'Success!',
          text: 'Your work has been saved',
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          handleClose()
          fnGetWorks()
          fnReset()
        })
      } else {
        Error_false(data)
      }
      setIsSave(false)
    } catch (error) {
      Error_500(error)
      setIsSave(false)
    }
  }
  const fnReset = () => {
    setError('company', false)
    setError('histyPosition', false)
    setError('duty', false)
    setError('fromYear', false)
    setError('toYear', false)
    setError('histyReason', false)
  }
  const handleClose = () => {
    setShowCreate(false)
    fnReset()
  }

  const fnDelete = () => {
    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to delete this?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        delEducation()
      }
    })
  }

  const delEducation = async () => {
    try {
      const res = await deleteWorksAPI({ ...param, histyWorkId: detail?.id })
      if (res.status) {
        SwalCustom({
          title: `Success!`,
          text: TXTSUCCESS,
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          handleClose()
          fnGetWorks()
          fnReset()
        })
      } else {
        Error_false(res)
      }
      setIsSave(false)
    } catch (error) {
      Error_500(error)
      setIsSave(false)
    }
  }

  const [disableYear, setDisableYear] = useState(null)
  const [disableYearStart, setDisableYearStart] = useState(null)
  const [disableYearEnd, setDisableYearEnd] = useState(null)

  useEffect(() => {
    const currentYear = () => {
      const d = new Date()
      let year = d.getFullYear()
      setDisableYearStart(year)
    }
    currentYear()
  }, [showCreate])

  return (
    <ModalCustom width={500} open={showCreate} onCancel={handleClose}>
      <Form
        onSubmit={handleSubmit(onSubmit)}
        className="mt-3 row"
        style={{ rowGap: '13px' }}
      >
        <label>Work History</label>
        <Col md={12}>
          <LabelCustom text={'Company Name'} />
          <Controller
            name={'company'}
            control={control}
            render={({
              field: { onChange, value = detail?.company ?? '' }
            }) => (
              <Form.Control maxLength={50} value={value} onChange={onChange} />
            )}
          />
          {errors.company?.message && (
            <label className="small text-danger">
              {errors.company.message}
            </label>
          )}
        </Col>
        <Col md={12}>
          <LabelCustom text={'Position'} />
          <Controller
            name={'histyPosition'}
            control={control}
            render={({
              field: { onChange, value = detail?.position ?? '' }
            }) => (
              <Form.Control maxLength={50} value={value} onChange={onChange} />
            )}
          />
          {errors.histyPosition?.message && (
            <label className="small text-danger">
              {errors.histyPosition.message}
            </label>
          )}
        </Col>
        <Col md={12}>
          <LabelCustom text={'Job description'} />
          <Controller
            name={'duty'}
            control={control}
            render={({
              field: { onChange, value = detail?.company ?? '' }
            }) => (
              <Form.Control maxLength={50} value={value} onChange={onChange} />
            )}
          />
          {errors.duty?.message && (
            <label className="small text-danger">{errors.duty.message}</label>
          )}
        </Col>
        <Col xl={6}>
          <LabelCustom text="From (พ.ศ.)" />

          <Controller
            name={'fromYear'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control
                maxLength={4}
                value={value}
                onKeyDown={handleKeyDownNum}
                onChange={(e) => {
                  setValue('fromYear', e.target.value)
                  setError('fromYear', false)
                }}
              />
              // <DatePicker
              //   style={{ fontFamily: 'Sarabun' }}
              //   defaultValue={
              //     detail?.from_year ? dayjs(detail?.from_year, 'YYYY') : ''
              //   }
              //   // value={value}
              //   className="form-control"
              //   onChange={(date, dateString) => {
              //     setValue('fromYear', dateString)
              //     setError('fromYear', date)
              //     setDisableYear(dateString)
              //   }}
              //   disabledDate={(current) =>
              //     current && disableYearEnd && disableYearStart >= disableYearEnd
              //       ? current.year() > parseInt(disableYearEnd)
              //       : disableYearStart &&
              //         current.year() > parseInt(disableYearStart)
              //   }
              //   picker="year"
              // />
            )}
          />
          {errors.fromYear?.message && (
            <label className="small text-danger">
              {errors.fromYear.message}
            </label>
          )}
        </Col>
        <Col xl={6}>
          <LabelCustom text="To (พ.ศ.)" />
          <Controller
            name={'toYear'}
            control={control}
            render={({ field: { onChange, value = '' } }) => (
              <Form.Control
                maxLength={4}
                value={value}
                onKeyDown={handleKeyDownNum}
                onChange={(e) => {
                  setValue('toYear', e.target.value)
                  setError('toYear', false)
                }}
              />
              // <DatePicker
              //   style={{ fontFamily: 'Sarabun' }}
              //   defaultValue={
              //     detail?.to_year ? dayjs(detail?.to_year, 'YYYY') : ''
              //   }
              //   // value={detail?.to_year ? dayjs(detail?.to_year, 'YYYY') : ''}
              //   className="form-control"
              //   onChange={(date, dateString) => {
              //     setValue('toYear', dateString)
              //     setError('toYear', dateString)
              //     setDisableYearEnd(dateString)
              //   }}
              //   disabledDate={(current) =>
              //     current &&
              //     disableYear &&
              //     current.year() < parseInt(disableYear)
              //   }
              //   picker="year"
              // />
            )}
          />
          {errors.toYear?.message && (
            <label className="small text-danger">{errors.toYear.message}</label>
          )}
        </Col>
        <Col xl={12}>
          <LabelCustom text="Reason for leaving" />
          <Controller
            name={'histyReason'}
            control={control}
            render={({
              field: { onChange, value = detail?.company ?? '' }
            }) => (
              <Form.Control
                maxLength={50}
                as="textarea"
                rows={3}
                value={value}
                onChange={onChange}
              />
            )}
          />
          {errors.histyReason?.message && (
            <label className="small text-danger">
              {errors.histyReason.message}
            </label>
          )}
        </Col>
        <Col xl={12} className="text-center">
          <Button
            className="px-4 me-2"
            variant="danger"
            type="button"
            disabled={isSave}
            onClick={fnDelete}
          >
            Delete
          </Button>
          <Button
            className="px-4 text-primary me-2"
            variant="light"
            type="button"
            disabled={isSave}
            onClick={handleClose}
          >
            Close
          </Button>

          <Button className="px-4 " disabled={isSave} type="submit">
            {isSave ? 'Saving...' : 'Save'}
          </Button>
        </Col>
      </Form>
    </ModalCustom>
  )
}
